import { createApp } from "vue";
import router from "./router";
import App from "./App.vue";
import VueCookies from "vue-cookies";
import "./main.css";

createApp(App).use(router).use(VueCookies).mount("#app");
